import * as actions from "./actions";
import { Map } from "immutable";
import { Record } from "../transit";
import { ValidationError } from "../lib/validation";
import cookie from "react-cookie";

const State = Record(
  {
    isOpen: false,
    isSent: false,
    form: new (Record(
      {
        loading: false,
        error: null
      },
      "form"
    ))()
  },
  "newsletter"
);

const newsletterReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.CREATE_NEWSLETTER: {
      return state.setIn(["form", "loading"], true).setIn(["isSent"], false);
    }

    case actions.CREATE_NEWSLETTER_SUCCESS: {
      const date = new Date();

      cookie.save("newsletterModal", true, {
        path: "/",
        expires: new Date(date.getTime() + 365 * 24 * 60 * 60 * 1000)
      });

      return state.setIn(["form", "loading"], false).setIn(["isSent"], true);
    }

    case actions.CREATE_NEWSLETTER_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "loading"], false);
    }

    case actions.CREATE_NEWSLETTER_FINALLY: {
      return state.setIn(["form", "loading"], false);
    }

    case actions.NEWSLETTER_CLEAR_ERROR: {
      const { field } = action.payload;

      let errors =
        state.form.error && state.form.error && state.form.error.errors;
      if (errors && errors[field]) {
        errors[field] = undefined;
      }

      return state.setIn(["form", "error"], new ValidationError(errors));
    }

    case actions.NEWSLETTER_CLEAR_FORM: {
      const { clearSentStatus } = action.payload;
      if (!clearSentStatus) {
        state = state.setIn(["isSent"], false);
      }

      return state.setIn(["form", "error"], null);
    }

    case actions.NEWSLETTER_SET_IS_OPEN: {
      const { isOpen } = action.payload;
      const date = new Date();
      if (isOpen === false) {
        cookie.save("newsletterModal", true, {
          path: "/",
          expires: new Date(date.getTime() + 7 * 24 * 60 * 60 * 1000)
        });
      } else if (cookie.load("newsletterModal") !== undefined) {
        return state;
      }

      return state.setIn(["isOpen"], isOpen);
    }

    default:
      return state;
  }
};

export default newsletterReducer;



/** WEBPACK FOOTER **
 ** ./src/common/newsletter/reducer.js
 **/